import { getEntries } from "../../../../helpers/Utils";
import { IRow } from "../../interfaces";

export const getColumnsWithoutLastElement = (rows: IRow, lastElementName) => {
	if (!lastElementName) {
		return getEntries(rows);
	}

	return getEntries(rows).map(([keyRow, { field, ...value }]) => {
		if (lastElementName) {
			delete value[lastElementName];

			return [keyRow, { ...value }];
		}
		return [keyRow, { ...value, field }];
	}) as any;
};
